var _rect, _rect2, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contact",
    clipPath: "url(#clip0_1910_1738)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3068,
    transform: "translate(-358 -2182)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1910_1738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -151,
    y: -1123,
    width: 1485,
    height: 1453
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_151_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M736.433 327.246L-147.236 -390.316C-151.523 -393.797 -152.177 -400.095 -148.695 -404.382L431.785 -1119.24C435.266 -1123.52 441.564 -1124.18 445.851 -1120.7L1329.52 -403.135C1333.81 -399.653 1334.46 -393.356 1330.98 -389.068L750.5 325.786C747.018 330.074 740.72 330.727 736.433 327.246Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1910_1738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 604"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -402.5,
    width: 396.556,
    height: 469,
    rx: 8.33459,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -402.5,
    width: 396.556,
    height: 469,
    rx: 8.33459,
    stroke: "#DADADA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1073714005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1073714023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bx-map.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.736 16.4085C17.3097 16.4085 19.4027 14.3155 19.4027 11.7419C19.4027 9.1682 17.3097 7.0752 14.736 7.0752C12.1623 7.0752 10.0693 9.1682 10.0693 11.7419C10.0693 14.3155 12.1623 16.4085 14.736 16.4085ZM14.736 9.40853C16.0228 9.40853 17.0693 10.455 17.0693 11.7419C17.0693 13.0287 16.0228 14.0752 14.736 14.0752C13.4492 14.0752 12.4027 13.0287 12.4027 11.7419C12.4027 10.455 13.4492 9.40853 14.736 9.40853Z",
    fill: "#0067B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0601 25.5249C14.2575 25.6659 14.4941 25.7417 14.7368 25.7417C14.9794 25.7417 15.216 25.6659 15.4134 25.5249C15.7681 25.2741 24.1039 19.2552 24.0701 11.7419C24.0701 6.59574 19.8829 2.40857 14.7368 2.40857C9.59059 2.40857 5.40342 6.59574 5.40342 11.7361C5.36959 19.2552 13.7054 25.2741 14.0601 25.5249ZM14.7368 4.7419C18.5973 4.7419 21.7368 7.8814 21.7368 11.7477C21.7613 16.9254 16.6174 21.5746 14.7368 23.0994C12.8573 21.5734 7.71226 16.9231 7.73676 11.7419C7.73676 7.8814 10.8763 4.7419 14.7368 4.7419Z",
    fill: "#0067B1"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_1738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3068,
    fill: "white",
    transform: "translate(-358 -2182)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.844022836a232727f8b6f51a98243961.svg";
export { ForwardRef as ReactComponent };